const DECIMALS = 2;
const FACTOR = 10 ** DECIMALS;

const twoDecimalFormat = new Intl.NumberFormat('sv-SE', { minimumFractionDigits: DECIMALS, maximumFractionDigits: DECIMALS });

export const roundToTwoDecimals = (value: number): number => {
    const rounded = (Math.sign(value) * Math.round(Number((Math.abs(value) * FACTOR).toPrecision(15)))) / FACTOR;
    return rounded === 0 ? 0 : rounded;
};

export const sumRounded = (values: number[]): number => roundToTwoDecimals(values.reduce((sum, v) => sum + roundToTwoDecimals(v), 0));

export const formatTwoDecimals = (value: number): string => twoDecimalFormat.format(roundToTwoDecimals(value));

export const formatPercent = (value: number): string => `${formatTwoDecimals(value)}%`;

export const percentChange = (from: number, to: number): number => (from !== 0 ? ((to - from) / from) * 100 : 0);

export const toDecimalInputValue = (value: number): string => roundToTwoDecimals(value).toFixed(DECIMALS).replace('.', ',');

export const toNumberInputValue = (value: number): string => roundToTwoDecimals(value).toFixed(DECIMALS);
